import { RootState } from 'types/redux';

/**
 * TODO - migrate
 * @param state
 */
export const selectMobileMenu = (state: RootState) =>
  state.profile.showMobileMenu;
